import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/crud_CLIENTES_POTENCIALES';

const clientes_potenciales = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title">Gestión Clientes Potenciales</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default clientes_potenciales;